import { render } from "./termination-modal.vue?vue&type=template&id=a24cde4a"
import script from "./termination-modal.vue?vue&type=script&lang=js"
export * from "./termination-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__